import React from 'react';
import { Main } from './components';

const Relocations = () => <Main />;

export default Relocations;
